import React, {type PropsWithChildren, ReactNode} from 'react';

interface OnImagesDidLoadProps {
  doesImagesUpdated: boolean;
  classNameWhileLoading: string;
  classNameOnloaded: string;
  onLoaded: () => void;
}

// Adapted from https://github.com/ProNoob702/onimagesdidload-ts/blob/a3621e9aa72ced894e070f8b61c7e91febf2a0b8/src/OnImagesDidLoad.tsx
export class OnImagesDidLoad extends React.Component<
  PropsWithChildren<OnImagesDidLoadProps>,
  {loadingImages: boolean},
  ReactNode
> {
  static defaultProps = {
    classNameWhileLoading: 'spinning',
    classNameOnloaded: 'imagesLoaded',
  };

  // Variables
  imagesLoadPromisesArray: Promise<boolean>[] = [];
  imgs: HTMLCollectionOf<HTMLImageElement>;
  envelopRef: React.RefObject<HTMLDivElement> = React.createRef();

  //state
  state = {
    loadingImages: true,
  };

  componentDidMount(): void {
    this.preparePromiesArray();
    this.resolveAllPromises();
  }

  componentDidUpdate(): void {
    if (!this.state.loadingImages && this.props.doesImagesUpdated) {
      this.setState(
        {
          loadingImages: true,
        },
        () => {
          this.preparePromiesArray();
          this.resolveAllPromises();
        }
      );
    }
  }

  preparePromiesArray = (): void => {
    const node = this.envelopRef.current;
    if (node) {
      this.imgs = node.getElementsByTagName('img');
      Array.from(this.imgs).map((img) => {
        this.imagesLoadPromisesArray.push(
          new Promise((resolve) => {
            if (img.complete) resolve(true);

            img.onload = () => {
              resolve(true);
            };
            img.onerror = () => {
              resolve(false);
            };
          })
        );
      });
    }
  };

  resolveAllPromises = (): void => {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    Promise.all(this.imagesLoadPromisesArray).then((_) => {
      self.setState(
        {
          loadingImages: false,
        },
        () => {
          self.imagesLoadPromisesArray.length = 0;
          self.props.onLoaded();
        }
      );
    });
  };

  render(): ReactNode {
    const {classNameWhileLoading, classNameOnloaded} = this.props;
    const classNamePrefix = this.state.loadingImages
      ? classNameWhileLoading
      : classNameOnloaded;
    return (
      <div ref={this.envelopRef} className={`${classNamePrefix}`}>
        {this.props.children}
      </div>
    );
  }
}
